import React, { useEffect, useState } from "react";
import { Globe, Search } from "lucide-react";
import { PageTitle, Table, Td, fmtDate } from "../../components/admin/AdminUi";
import { api } from "../../lib/api";

export default function AdminProjects() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { const t = setTimeout(() => api.adminProjects({ q }).then(setRows).catch(() => {}), 250); return () => clearTimeout(t); }, [q]);
  return (
    <div data-testid="admin-projects">
      <PageTitle title="Projects" desc="Every app built on the platform." right={
        <div className="relative"><Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-500" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name" data-testid="admin-projects-search" className="h-8 w-56 pl-8 pr-3 rounded-lg bg-slate-100 border border-slate-200 text-sm text-slate-900 outline-none" /></div>
      } />
      <Table head={["Project", "Owner", "Versions", "Model", "Status", "Updated"]} testid="admin-projects-table" empty={rows.length === 0 && "No projects yet."}>
        {rows.map((p) => (
          <tr key={p.id} data-testid={`admin-project-row-${p.id}`} className="hover:bg-slate-50">
            <Td><div className="text-slate-900">{p.name}</div>
              {p.published_version_id && <a href={`/p/${p.slug}`} target="_blank" rel="noreferrer" className="text-xs text-emerald-600 flex items-center gap-1 hover:underline"><Globe size={11} /> /p/{p.slug}</a>}</Td>
            <Td><div className="text-slate-600">{p.owner_name}</div><div className="text-xs text-slate-500">{p.owner_email}</div></Td>
            <Td className="font-mono">{p.version_count}</Td>
            <Td className="text-xs font-mono text-slate-500">{p.model}</Td>
            <Td className="text-xs">{p.status === "generating" ? <span className="text-amber-600">building</span> : <span className="text-slate-500">idle</span>}</Td>
            <Td className="text-xs text-slate-500 whitespace-nowrap">{fmtDate(p.updated_at)}</Td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
